<template>
  <div class="mt-2">
    <h1>
      {{ tool.model }}
      <small class="text-muted" v-if="$store.state.currentRegion in tool.name">
        {{ tool.name[$store.state.currentRegion] }}
      </small>
    </h1>
    <b-row>
      <b-col md="8">
        <b-img fluid :src="tool.image" :alt="tool.model" />
        <b-card no-body>
          <b-card-body>
            <b-card-title class="mb-0">Get this tool</b-card-title>
          </b-card-body>
          <b-list-group flush>
            <b-list-group-item v-for="link in buyLinks" :key="link.sku + '-' + link.programId"
                               :href="link.trackingUrl ? link.trackingUrl : link.productUrl"
                               class="d-flex product">
              <b-img width="64" :alt="link.productName" :src="link.imageUrl" class="mr-3" />
              <div class="d-flex flex-column w-100">
                <p class="product-name">{{ link.productName }}</p>
                <p class="mb-0 d-flex justify-content-between">
                  <span>{{ link.programName }}</span>
                  <i18n-n :value="link.productPrice" :format="{ style: 'currency', currency: link.currency, minimumFractionDigits: 0 }" class="product-price"></i18n-n>
                </p>
              </div>
            </b-list-group-item>
          </b-list-group>
          <b-card-footer class="border-top-0">
            By using these links I get a small percentage of your purchase, which is really awesome since it helps pay for hosting and other costs!
          </b-card-footer>
        </b-card>
      </b-col>
      <b-col md="4">
        <b-card no-body>
          <b-card-body>
            <b-card-title class="mb-0">{{ $t('text.links') }}</b-card-title>
          </b-card-body>
          <b-list-group flush>
            <b-list-group-item v-for="(url, region) in tool.url" :key="region"
                               :href="url" target="_blank">
              Ryobi
              {{ $t('region.' + region) }}
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Adtraction from '@/util'

export default {
  name: 'Product',
  props: ['model'],
  data () {
    return {
      buyLinks: []
    }
  },
  computed: {
    tool () {
      return this.$root.tools[this.model]
    }
  },
  methods: {
    async loadBuyLinks () {
      this.buyLinks = await Adtraction.getProducts(this.model, true)
    }
  },
  async created () {
    await this.loadBuyLinks()
  }
}
</script>

<style lang="scss">
  .product {
    img {
      object-fit: contain;
      object-position: center;
    }
  }
</style>